export const RENDERER_ANNOTATION_PROVIDER_FF =
	'confluence.frontend.renderer.annotation.provider.inline.comments';
export const RENDERER_ANNOTATION_PROVIDER_SSR_FF =
	'confluence.ssr.renderer.annotation.provider.inline.comments';
